import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
// import history from '../../history';
import {Translate} from 'react-redux-i18n';

import ExerciseBenchmarkList from '../ExerciseBenchmark/List';
import Loading from '../../components/Loading/Loading';
import style from './ExerciseCreate.module.css';

import {
  changeForm as changeFormAction,
  create as createAction,
  selectScenario as selectScenarioAction,
  fetchScenarios as fetchScenariosAction,
  clearExercise as clearExerciseAction,
} from './ExerciseCreateActions';

function ExerciseCreate(props) {
  const { 
    connected, 
    fetchScenarios, 
    clearExercise,
    changeForm,
    selectScenario,
    create: createProp,
    exercise,
    error,
    loading,
    scenarios,
    createdId
  } = props;

  const navigate = useNavigate();

  useEffect(() => {
    if (!connected) {
      navigate('/exercises');
    } else if (createdId) {
      navigate(`/exercises/${createdId}`);
    } else {
      clearExercise();
      fetchScenarios();
    }
  }, [connected, fetchScenarios, clearExercise, navigate, createdId]);

  function changeField(e) {
    e.preventDefault();

    const { id, value } = e.target;

    changeForm(id, value);
  }

  function changeCodeField(e) {
    e.preventDefault();

    const id = e.target.id;
    const value = e.target.value.toLowerCase();

    changeForm(id, value);
  }

  function handleSelectChange(e) {
    e.preventDefault();

    selectScenario(e.target.value);
  }

  function back() {
    navigate('/exercises');
  }

  function create() {
    const { name, code, selected } = exercise;

    const newExercise = {
      name,
      code,
      scenarioId: selected,
    };

    createProp(newExercise, navigate);
  }

  const { name, code, selected } = exercise;

  return (
    <div className="row">
      <div className="col-md-12 mt-4">
        {/*{ loading && <Loading /> }*/}
        <h3><strong><Translate value="createExercise.title"/></strong></h3>
        <hr />
        <div className="row">
          <div className="col-md-6">
            <Translate value="createExercise.desc"/>
            <div className="row">
              { error &&
                <div className="col-sm-12">
                  <div className="alert alert-danger">{ error }</div>
                </div>
              }
              <div className="col-sm-12">
                <div className="mb-3">
                  <label className="control-label" htmlFor="name">
                    <Translate value="createExercise.Name"/>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    value={name}
                    onChange={changeField}
                  />
                </div>
                <div className="mb-3">
                  <label className="control-label" htmlFor="code">
                    <Translate value="createExercise.Code"/>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="code"
                    value={code}
                    onChange={changeCodeField}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-12" style={{padding: 0}}>
              <div className="mb-3">
                <label className="control-label" htmlFor="scenarios">
                  <Translate value="common.Scenarios"/>:
                </label>
                <select
                  value={selected}
                  onChange={handleSelectChange}
                  size="8"
                  id="scenarios"
                  className={style.select}
                >
                  <option value="" hidden />
                  { (scenarios || []).map(scenario =>
                    <option
                      key={scenario.id}
                      value={scenario._id}
                    >
                      {scenario.title}
                    </option>)
                  }
                </select>
              </div>
            </div>
            <div className="col-sm-12">
              <button
                className="btn btn-primary"
                onClick={create}
                disabled={loading || !name || !code || !selected}
              >
                <i className="fas fa-plus" /> <Translate value="controls.Create"/>
              </button>
              <button
                className={`btn btn-danger ${style.back} float-end`}
                onClick={back}
                disabled={loading}
              >
                <i className="fas fa-times" /> <Translate value="controls.Cancel"/>
              </button>
            </div>
          </div>
          <div className="row col-md-6" style={{borderLeft: '1px solid #eee', paddingLeft: 10, marginLeft: 10}}>
            <ExerciseBenchmarkList showPreviewButtonOnly descriptionOption="exercise.BenchmarkCreateDescription" />
          </div>
        </div>
      </div>
    </div>
  );
}

ExerciseCreate.propTypes = {
  loading: PropTypes.bool,
  exercise: PropTypes.object,
  scenarios: PropTypes.array,
  connected: PropTypes.bool,
  error: PropTypes.string,
  changeForm: PropTypes.func,
  selectScenario: PropTypes.func,
  fetchScenarios: PropTypes.func,
  create: PropTypes.func,
  clearExercise: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.exerciseCreate.loading,
  exercise: state.exerciseCreate.exercise,
  scenarios: state.exerciseCreate.data,
  error: state.exerciseCreate.error,
  connected: state.socket.connected,
  createdId: state.exerciseCreate.createdId,
});

const mapDispatchToProps = {
  changeForm: changeFormAction,
  selectScenario: selectScenarioAction,
  fetchScenarios: fetchScenariosAction,
  create: createAction,
  clearExercise: clearExerciseAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExerciseCreate);

